import $http from "../../helpers/api";

// initial state
const state = {
    all: [],
    inventory: []
};

// getters
const getters = {
    getInventory() {
        return state.inventory;
    },
    getAll() {
        return state.all;
    }
};

// actions
const actions = {
    getInventory({
        commit
    }, asfId) {
        return new Promise(resolve => {
            $http.get("/inventories/" + asfId + "?includes[]=type&includes[]=part").then(resp => {
                commit("set", resp.data.inventory);
                resolve();
            });
        });
    },
    getAllInventory({
        commit,
        rootGetters
    }, asfId) {
        return new Promise(resolve => {
            $http.get("/inventories", {
                params: {
                    includes: [
                        "type", "part"
                    ],
                    filter_groups: [{
                        filters: [{
                            key: "asf_id",
                            value: rootGetters["auth/getCurrentAsf"],
                            operator: "eq"
                        }]
                    }]
                }
            }).then(resp => {
                commit("setAll", resp.data.inventories);
                resolve();
            });
        });
    },
    edit({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            $http.put("/inventories/" + data.id, {
                inventory: data
            }).then(resp => {
                commit("clear");
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete({}, data) {
        return new Promise((resolve, reject) => {
            $http.delete("/inventories/" + data).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    }
};

// mutations
const mutations = {
    setAll(state, inventory) {
        state.all = inventory;
    },
    set(state, inventory) {
        state.inventory = inventory;
    },
    clear(state) {
        state.inventory = null;
    },
    clearAll(state) {
        state.all = [];
        state.inventory = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
